import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

import async from '@xanadu/ui-shared/components/asyncComponent';

const AsyncPromotions = async(() =>
  import('../components/promotions/Promotions').then(module => module.default)
);

const AsyncExchangePromotionsPage = async(() =>
  import('../components/promotions/ExchangePromotionsPage').then(module => module.default)
);

const AsyncCasinoPromotionsPage = async(() =>
  import('../components/promotions/CasinoPromotionsPage').then(module => module.default)
);

function RouteHandler({
  match: {
    params: {
      section = 'exchange',
      promoId
    },
  }
}) {
  if (promoId && section === 'exchange') {
    return (
      <AsyncExchangePromotionsPage
        id={promoId}
      />
    );
  }

  if (promoId && section === 'casino') {
    return (
      <AsyncCasinoPromotionsPage
        id={promoId}
      />
    );
  }

  return (
    <AsyncPromotions
      section={section}
    />
  );
}

RouteHandler.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      section: PropTypes.string,
      promoId: PropTypes.string
    })
  }).isRequired
};

export default withRouter(RouteHandler);
